import {X, ChevronRight, Bell} from "lucide-react";

export function FormModal({title, eyebrow, close, children, width = 570, testId = "modal"}) {
  return (
    <div className="modal-backdrop" data-testid={`${testId}-backdrop`} onClick={close}>
      <div className="modal" style={{maxWidth: width}} onClick={e => e.stopPropagation()}>
        <button data-testid="modal-close" className="modal-close" onClick={close}><X size={18}/></button>
        <div className="eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  );
}

export function SectionHead({eyebrow, title, action, onAction}) {
  return (
    <div className="section-head">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      {action && (
        <button data-testid="section-view-all" className="text-button" onClick={onAction}>
          {action}<ChevronRight size={16}/>
        </button>
      )}
    </div>
  );
}

export function Coming({title, notify}) {
  return (
    <div className="coming" data-testid={`coming-${title.toLowerCase()}`}>
      <div className="eyebrow">INDIAN OCEAN</div>
      <h1>{title}<br/><em>is taking shape.</em></h1>
      <p>This space is being thoughtfully prepared for your community.</p>
      <button data-testid="coming-button" className="coral-button" onClick={() => notify(`${title} updates will be shared with you`)}>
        Keep me posted <Bell size={16}/>
      </button>
    </div>
  );
}
